import React from 'react';

import { useLayoutStyles } from './layout.style';
import { createSlots } from './slots';

const { slots, useSlots } = createSlots('Layout', [
  'nav',
  'header',
  'main',
] as const);

const LayoutBase: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { nav, header, main } = useSlots(children);
  const styles = useLayoutStyles();

  return (
    <div className={styles.container}>
      <div className={styles.nav}>{nav}</div>
      <div className={styles.body}>
        <header className={styles.header}>{header}</header>
        <main className={styles.main}>{main}</main>
      </div>
    </div>
  );
};

const Layout = Object.assign(LayoutBase, {
  Nav: slots.Nav,
  Header: slots.Header,
  Main: slots.Main,
});

export default Layout;
